import { forwardRef } from 'react';
import type { AppIconComponent, AppIconProps } from './app-icon';

const SEEDANCE_SYMBOL_ASSET = '/brand/bytedance-seed-symbol.png';

export const SeedanceBrandIcon: AppIconComponent = forwardRef<
  SVGSVGElement,
  AppIconProps
>(({ size = 24, ...props }, ref) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={size}
    ref={ref}
    viewBox="0 0 96 96"
    width={size}
    {...props}
  >
    <image
      x="0"
      y="0"
      width="96"
      height="96"
      href={SEEDANCE_SYMBOL_ASSET}
      preserveAspectRatio="xMidYMid meet"
    />
  </svg>
));

SeedanceBrandIcon.displayName = 'SeedanceBrandIcon';
